module.exports = __webpack_public_path__ + "assets/img/autograde_start_img1.svg";